import React, { useState, useEffect } from "react";

function DynamicScreen() {
  const images = [
    "chats.png",
    "map.png",
    "notifications.png",
    "grid.png",
    "post.png",
    "profile.png",
  ]; // Array of image paths

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (images.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [images.length]);

  return (
    <div className=" flex  h-[650px] items-center justify-center ">
      {" "}
      {/* Increased height */}
      {images.map((image, index) => (
        <img
          key={index}
          src={require(`../assets/features/${image}`)}
          alt={`Slide ${index}`}
          className="max-h-full object-cover bg-transparent"
          style={{
            display: index === currentIndex ? "block" : "none",
          }}
        />
      ))}
    </div>
  );
}

export default DynamicScreen;
